function generateRandomId(length = 10) {
	const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
	let result = '';
	for (let i = 0; i < length; i++) {
		result += characters.charAt(Math.floor(Math.random() * characters.length));
	}
	return result;
}

/**
 * initAccordions
 * TODO: https://van11y.net/accessible-accordion/ - try this out in the next iteration
 */
function initAccordions() {
	const accordion = document.querySelectorAll('.wp-block-zp4-accordion .accordion-toggle');
	for (let i = 0; i < accordion.length; i++) {
		const uniqueId = generateRandomId();
		const headerId = `accordion-header-${uniqueId}`;
		const panelId = `accordion-panel-${uniqueId}`;

		accordion[i].id = headerId;
		accordion[i].nextElementSibling.id = panelId;

		accordion[i].onclick = function () {
			this.classList.toggle('is-active');
			this.nextElementSibling.classList.toggle('is-active');
			if (this.getAttribute('aria-expanded') === 'true') {
				this.setAttribute('aria-expanded', 'false');
			} else {
				this.setAttribute('aria-expanded', 'true');
			}
		};
	}
}

window.addEventListener(
	'load',
	function () {
		initAccordions();
	},
	false
);

